function normalizeText(value?: string | null) {
  const normalized = String(value || '').trim();
  return normalized.length > 0 ? normalized : '';
}

export function buildInvoicePaymentReference(invoiceNumber?: string | null, rfiTicketNumber?: string | null) {
  const normalizedInvoiceNumber = normalizeText(invoiceNumber);
  if (normalizedInvoiceNumber) {
    return normalizedInvoiceNumber;
  }

  const ticket = normalizeText(rfiTicketNumber).toUpperCase();
  if (ticket) {
    return ticket.startsWith('RFI-') ? ticket : `RFI-${ticket}`;
  }

  return normalizedInvoiceNumber;
}
